import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-01f1b650"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "categories-tree-item my-3"
}
const _hoisted_2 = { class: "categories-tree-item-content d-flex align-items-center" }
const _hoisted_3 = ["href"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas me-1 mb-1" }, "chevron_right", -1))
const _hoisted_5 = {
  key: 1,
  class: "name m-0 ps-4"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "mas fs-5" }, "add", -1))
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = ["id"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProductCategoriesTreeItem = _resolveComponent("ProductCategoriesTreeItem", true)!

  return (this.categoryExists)
    ? (_openBlock(), _createElementBlock("li", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          (this.hasChildren)
            ? (_openBlock(), _createElementBlock("a", {
                key: 0,
                role: "button",
                "data-bs-toggle": "collapse",
                href: '#' + this.collapseId,
                class: "name d-flex align-items-center text-decoration-none lh-1"
              }, [
                _hoisted_4,
                _createElementVNode("span", null, _toDisplayString(this.categoriesTreeItem.current_category.description), 1)
              ], 8, _hoisted_3))
            : (_openBlock(), _createElementBlock("p", _hoisted_5, "  " + _toDisplayString(this.categoriesTreeItem.current_category.description), 1)),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (this.selectCategory(this.categoriesTreeItem.current_category.code)), ["prevent"])),
            class: "btn btn-icon btn-sm btn-light ms-3"
          }, _hoisted_7)
        ]),
        (_ctx.hasChildren)
          ? (_openBlock(), _createElementBlock("ul", {
              key: 0,
              class: "categories-tree-item-children collapse m-0 ms-4 p-0",
              id: _ctx.collapseId
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(this.categoriesTreeItem.subcategories, (subCategory) => {
                return (_openBlock(), _createBlock(_component_ProductCategoriesTreeItem, {
                  key: subCategory.description,
                  "categories-tree-item": subCategory,
                  onSelectCategory: this.selectCategory
                }, null, 8, ["categories-tree-item", "onSelectCategory"]))
              }), 128))
            ], 8, _hoisted_8))
          : _createCommentVNode("", true)
      ]))
    : _createCommentVNode("", true)
}